<!--
  - Copyright (c) 2020 brightlamp
  -->

<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="400">
            <v-card>
                <v-card-title class="headline" style="color:#FFFD00;background-color:#363636;">Edit Card</v-card-title>
                <div class="ma-4">
                    <v-row>
                        <v-col>
                            <v-select v-model="month" :items="months" label="Expiry month" outlined></v-select>
                        </v-col>
                        <v-col>
                            <v-select v-model="year" :items="years"  label="Expiry year" outlined></v-select>
                        </v-col>
                    </v-row>
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="cancel">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="update" :loading="waiting" :disabled="waiting">Update</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'

    export default
    {
        name: 'edit-credit-card-dialog',
        data: function ()
        {
            return {
                dialog: Boolean(true),
                monthSelected: '',
                yearSelected: '',
                months: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
                years: ['2022', '2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030', '2031', '2032', '2033', '2034', '2035', '2036', '2037', '2038', '2039', '2040', '2041']
            }
        },
        props:
        {
            forOrg: null,
            cardIndex: 0
        },
        computed:
        {
            ...mapState('customerBilling',
            {
                paymentInfo: state => state.paymentInfo
            }),
            ...mapState('common',
            {
                waiting: state => state.waiting
            }),
            month:
            {
                get: function()
                {
                    if ('' === this.monthSelected)
                    {
                        this.monthSelected = String(this.paymentInfo.cards[this.cardIndex].expMonth).padStart(2, '0')
                    }
                    return this.monthSelected
                },
                set: function(newValue)
                {
                    this.monthSelected = newValue
                }
            },
            year:
            {
                get: function()
                {
                    if ('' === this.yearSelected)
                    {
                        this.yearSelected = String(this.paymentInfo.cards[this.cardIndex].expYear)
                    }
                    return this.yearSelected
                },
                set: function(newValue)
                {
                    this.yearSelected = newValue
                }
            }
        },
        mounted()
        {
            this.$logEvent(this.$firebaseAnalytics, 'screen_view',
            {
                app_name: 'Web Portal',
                screen_name: `Reflex Web Portal - ${this.$options.name}`,
                app_version: process.env.VUE_APP_VERSION
            });
        },
        methods:
        {
            ...mapMutations('common', ['WAITING', 'SHOW_SNACKBAR_ERROR', 'HIDE_SNACKBAR']),
            ...mapActions('customerBilling', ['SET_PAYMENT_INFO', 'SET_ORG_PAYMENT_INFO']),
            async update()
            {
                try
                {
                    this.HIDE_SNACKBAR();
                    this.WAITING(true);
                    this.paymentInfo.cards[this.cardIndex].expMonth = parseInt(this.monthSelected);
                    this.paymentInfo.cards[this.cardIndex].expYear = parseInt(this.yearSelected);
                    if (this.forOrg)
                    {
                        await this.SET_ORG_PAYMENT_INFO({orgId: this.forOrg, data: this.paymentInfo})
                    }
                    else
                    {
                        await this.SET_PAYMENT_INFO(this.paymentInfo)
                    }
                    this.WAITING(false);
                    this.$emit('edit-credit-card-dialog-response')
                }
                catch (error)
                {
                    this.SHOW_SNACKBAR_ERROR(error.response && error.response.data && error.response.data.reason ? error.response.data.reason : error.message);
                    this.WAITING(false);
                    this.cancel(true)
                }
            },
            cancel(reload = false)
            {
                this.$emit('edit-credit-card-dialog-response', reload)
            }
        }
    };
</script>

<style scoped>
</style>